import React, { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { Download } from '../../_lib/components/Download';
import { Namespace } from '../../translation/namespace';
import ILink from '../../types/ILink';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';

function PersonVCard({ vcardUrl }: { vcardUrl: ILink }) {
  const { t } = useTranslation(Namespace.phrases);
  const exportVCard = t('vCardExport');

  return (
    <div className="widget__footer widget__footer--left widget__footer--no-border">
      <h2 className="invisible">{exportVCard}</h2>
      {/* props for <Download> are partly hardcoded, because values are static */}
      <Download
        url={vcardUrl.url}
        fileName={exportVCard}
        fileExtension="vcf"
        mimeType="text/vcard"
        fileSizeBytes={1024}
      />
    </div>
  );
}

export const PersonVCardBlock = asBlock(PersonVCard, BlockType.personvcard);
export type PersonVCardBlock = ComponentProps<typeof PersonVCardBlock>;
